import { getSellerLocale } from "common";
import { Seller, User } from "types";
import { config } from "../config";
import { loadScript } from "../utils/loadScript";
import { getReleaseInfo } from "./helpers";
import { registerSnippet } from "./index";

let isLocalizeLoading = false;

const initializeToEmptyIfNotAvailable = () => {
    if (!window.Localize) {
        const methods = [
            "translate",
            "untranslate",
            "phrase",
            "initialize",
            "transl                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             atePage",
            "setLanguage",
            "getLanguage",
            "getSourceLanguage",
            "detectLanguage",
            "getAvailableLanguages",
            "untranslatePage",
            "bootstrap",
            "prefetch",
            "on",
            "off",
            "hideWidget",
            "showWidget",
        ];

        window.Localize = {};

        for (const method of methods) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            window.Localize[method] = function () {};
        }
    }
};

export const load = async (): Promise<void> => {
    const { env } = getReleaseInfo();
    const shouldSaveNewPhrases = env !== "development";
    const url = "https://global.localizecdn.com/localize.js";

    if (window.Localize) return;

    if (isLocalizeLoading) {
        /** If there is a script already in progress, we don't need to load a new one, just wait for the last one to finish */
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                if (!isLocalizeLoading) {
                    clearInterval(interval);
                    resolve();
                }
            }, 100);
        });
    }

    isLocalizeLoading = true;

    return new Promise((resolve) => {
        loadScript(url, "localize", () => {
            initializeToEmptyIfNotAvailable();

            window.Localize.initialize({
                key: config.localize.key,
                disableWidget: true,
                translateAlt: false,
                translateAriaLabels: false,
                rememberLanguage: false,
                translateSVGElement: false,
                saveNewPhrases: shouldSaveNewPhrases,
                blockedClasses: [
                    "ReactQueryDevtools",
                    "no-translate",
                    "ui-currency",
                    "ui-currency-split",
                    "iframe-content",
                    "ui-combo-box",
                    "error-boundary",
                    "fc-toolbar-title",
                    "DayPicker-Months",
                    "window",
                ],
            });

            isLocalizeLoading = false;
            resolve();
        });
    });
};

registerSnippet("Localize", config.localize.enabled, async (user: User, seller: Seller) => {
    if (!seller || !user) {
        return;
    }

    const locale = getLocale(user, seller);

    if (locale === "en" || locale === "en_US") {
        /** Seller doesn't have translation enabled, so we don't need to load the localize.js script */
        return;
    }

    return load();
});

export const getLocale = (user: User, seller: Seller) => {
    if (user.locale) {
        return user.locale;
    }

    return getSellerLocale(seller);
};
